import { useEffect, useState } from 'react';
import useClient from 'api/client';
import createOrganization from 'api/Organization/createOrganization';
import { NewOrganizationInput } from 'types/Organization';
import getUserGroups from 'api/Organization/getUserGroups';

export default function useCreateOrganization() {
    const client = useClient();
    const [loading, setLoading] = useState(true);
    const [buttonLoading, setButtonLoading] = useState(false);
    const [adGroupOptions, setAdGroupOptions] = useState<{ value: string }[]>(
        [],
    );

    const fetchGroups = async () => {
        setLoading(true);
        const response = await client?.query(getUserGroups());
        if (!response.errors) {
            const groups: string[] = response.data.getUserGroups.nodes;
            setAdGroupOptions(
                groups.map((item) => ({ value: item, label: item })),
            );
        }
        setLoading(false);
    };

    useEffect(() => {
        if (client) {
            fetchGroups();
        }
    }, [client]);

    const handleSubmit = async (
        dataset: NewOrganizationInput,
        setCreationError: React.Dispatch<React.SetStateAction<string>>,
    ) => {
        setButtonLoading(true);
        try {
            const response = await client.mutate(createOrganization(dataset));

            if (!response.errors) {
                return response.data.createOrganization;
            } else {
                setCreationError(response.errors[0].message);
                return null;
            }
        } finally {
            setButtonLoading(false);
        }
    };

    return { loading, adGroupOptions, buttonLoading, handleSubmit };
}
